<div class="mosaico-projetos">
  <div class="mosaico">
    <ng-container *ngFor="let project of mozaicItems; trackBy: trackByFn">
      <ng-container [ngTemplateOutlet]="mozaicItemTemplateRef" [ngTemplateOutletContext]="{ $implicit: project }">
      </ng-container>
    </ng-container>
  </div>
</div>
